// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"893a08c0","453":"28fb15c2","619":"dea7a837"}[chunkId] + ".chunk.js";
};